export default { sha: '2a5f494ceefc418ec0e4a9ddad3e8b16cf039d6e', buildNumber: 'undefined' }
